var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { defineComponent, useSlots, computed, createBlock, openBlock, mergeProps, unref, isRef, withCtx, createVNode, renderSlot, normalizeClass, createElementBlock, Fragment, renderList, createCommentVNode, resolveDynamicComponent } from "vue";
import { useBetterVModel } from "../../../../composables/useBetterVModel.js";
import { useRealProps, propsToCamelKeyProps } from "../../../../composables/useRealProps.js";
import { SmartRenderer, resolveVNode } from "../../../../lib/utils.js";
import _sfc_main$1 from "../core/Tabs.js";
import _sfc_main$2 from "../core/TabsList.js";
import _sfc_main$3 from "../core/TabsTrigger.js";
import { u as useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabsWrapper",
  props: {
    layout: {},
    tabsListClass: {},
    class: {},
    size: {},
    orientation: {},
    type: {},
    defaultValue: {},
    dir: {},
    activationMode: {},
    modelValue: {},
    unmountOnHide: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props, emits = __emit, tabsProps = reactiveOmit(props, ["layout", "tabsListClass"]), forwarded = useForwardPropsEmits(tabsProps, emits), slots = useSlots(), defaultSlots = computed(() => {
      var _a;
      return ((_a = slots.default) == null ? void 0 : _a.call(slots)) ?? [];
    });
    function getDefaultValue() {
      var _a;
      if (props.defaultValue)
        return props.defaultValue;
      if (defaultSlots.value.length > 0) {
        const item = defaultSlots.value.find((s) => {
          var _a2, _b;
          return !((_a2 = s == null ? void 0 : s.props) != null && _a2.disabled || ((_b = s == null ? void 0 : s.props) == null ? void 0 : _b.disabled) === "");
        });
        return (_a = item == null ? void 0 : item.props) == null ? void 0 : _a.id;
      }
    }
    __name(getDefaultValue, "getDefaultValue");
    const realProps = useRealProps(), modelValue = useBetterVModel({ props, realProps, key: "modelValue", emits, defaultValue: getDefaultValue() }), indexRef = computed(() => defaultSlots.value.findIndex((s) => {
      var _a;
      return ((_a = s == null ? void 0 : s.props) == null ? void 0 : _a.id) === modelValue.value;
    }));
    return (_ctx, _cache) => (openBlock(), createBlock(_sfc_main$1, mergeProps({
      modelValue: unref(modelValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(modelValue) ? modelValue.value = $event : null),
      orientation: props.layout
    }, unref(forwarded)), {
      default: withCtx(() => [
        createVNode(_sfc_main$2, {
          class: normalizeClass(props.tabsListClass)
        }, {
          default: withCtx(() => [
            (openBlock(!0), createElementBlock(Fragment, null, renderList(defaultSlots.value, (item, index) => {
              var _a;
              return openBlock(), createElementBlock(Fragment, {
                key: (_a = item == null ? void 0 : item.props) == null ? void 0 : _a.id
              }, [
                item.props ? (openBlock(), createBlock(_sfc_main$3, {
                  key: 0,
                  class: normalizeClass(unref(propsToCamelKeyProps)(item.props).titleClass),
                  value: item.props.id,
                  disabled: item.props.disabled,
                  divider: indexRef.value + 1 !== index
                }, {
                  default: withCtx(() => [
                    typeof (item == null ? void 0 : item.children) == "object" && (item != null && item.children) && !Array.isArray(item == null ? void 0 : item.children) && item.children.title ? (openBlock(), createBlock(resolveDynamicComponent(item.children.title), { key: 0 })) : (openBlock(), createBlock(unref(SmartRenderer), {
                      key: 1,
                      children: unref(resolveVNode)(item.props.title)
                    }, null, 8, ["children"]))
                  ]),
                  _: 2
                }, 1032, ["class", "value", "disabled", "divider"])) : createCommentVNode("", !0)
              ], 64);
            }), 128))
          ]),
          _: 1
        }, 8, ["class"]),
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "orientation"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TabsWrapper.js.map
